import _isEqual from 'lodash/isEqual'
import _omitBy from 'lodash/omitBy'

export function isAnyOf (value, arr) {
  return arr.findIndex(el => _isEqual(el, value)) !== -1
}

export function isValueEmpty (value) {
  return isAnyOf(value, [ '', {}, [], null, undefined ])
}

export function isValueEqual (a, b) {
  const areBothEmpty = isValueEmpty(a) && isValueEmpty(b)
  if (areBothEmpty) return true
  if (typeof a !== typeof b) return false
  if (Array.isArray(a) && Array.isArray(b)) {
    return _isArrayEqual(a, b)
  } else if (typeof a === 'object' && typeof b === 'object') {
    return _isObjectEqual(a, b)
  }
  return _isEqual(a, b)
}

function _isObjectEqual (a, b) {
  // It omits empty values, so { a: 1, b: null } and { a: 1, b: '' } are equal
  // Since this function should be use only in form-value-like comparisons, this is expected behaviour
  const aNormalized = _omitBy(a, isValueEmpty)
  const bNormalized = _omitBy(b, isValueEmpty)
  const aKeys = Object.keys(aNormalized)
  const bKeys = Object.keys(bNormalized)
  if (!_isEqual(aKeys, bKeys)) return false
  return !aKeys.some((aKey) => !isValueEqual(aNormalized[aKey], bNormalized[aKey]))
}

function _isArrayEqual (a, b) {
  if (a.length !== b.length) return false
  return !a.some((aItem, aIndex) => !isValueEqual(aItem, b[aIndex]))
}
